import React from 'react';
import moment from 'moment';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import transformDisplayText from 'src/helpers/transformDisplayText';

function ReadOnlyControl(props) {
  const { label, value, listOptions, origControlTypeName, helpText } = props;

  let finalValue = value && value !== '' && origControlTypeName === 'Date' ? moment(value).format('DD-MMM-YYYY') : value;
  if (listOptions) {
    listOptions.forEach(item => {
      if (item.lookUpBindValue === value) {
        finalValue = item.displayText;
      }
    });
  }

  return (
    <div className="parser-readonly-control">
      <label className="readonly-label">
        {transformDisplayText(label)}
        {helpText && <span>&nbsp;&nbsp;</span>}
        {helpText && <InfoTooltip toolTipText={helpText} />}
      </label>
      <span className="readonly-content">{transformDisplayText(finalValue)}</span>
    </div>
  );
}

export default ReadOnlyControl;



// WEBPACK FOOTER //
// ./src/ui/library/ContentParser/controls/ReadOnlyControl/ReadOnlyControl.js